<mat-accordion class="width-block">
    <!-- #enddocregion basic-panel -->
    <mat-expansion-panel [expanded]="panelOpenState === true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Question Quantité - {{Question.title}}
            </mat-panel-title>
            <mat-panel-description *ngIf="response">
                {{response}}
            </mat-panel-description>

            <div class="valid" *ngIf="show">Répondu</div>
            <div class="invalid" *ngIf="!show">En cours</div>
        </mat-expansion-panel-header>

        <div class="display-content" *ngIf="Question.displayMode == 0">
            <mat-form-field class="quantity-form-field" *ngFor="let option of Question.options" #multiple>
                <mat-label>{{option.title}}</mat-label>
                <input matInput type="number" [(ngModel)]="option.result" min="0" (keypress)="integerOnly($event)"  (ngModelChange)="lessOrMore($event, option)">
                <button mat-button *ngIf="option.order" matSuffix mat-icon-button aria-label="Clear" (click)="option.order = ' '">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <!-- Slider -->
        <div #slider class="display-around" *ngIf="Question.displayMode == 1">
            <div> Min : {{Question.minLabel}} </div>
            <mat-slider thumbLabel (ngModelChange)="searchLinkSlider($event)" step="1" [min]="Question.minValue" [max]="Question.maxValue" [(ngModel)]="option.result"></mat-slider>
            <div> Max : {{Question.maxLabel}} </div>
            <div>Selection : {{ option.result }}</div>
        </div>

        <!-- Choix multiple -->
        <div *ngIf="Question.displayMode == 4">
            <mat-selection-list #choices [(ngModel)]="selectedOptions" (ngModelChange)="onNgModelChange($event)">
                <mat-list-option *ngFor="let option of sortBy('order')" [value]="option" [selected]="option.checked">
                    {{option.title}}
                </mat-list-option>
            </mat-selection-list>
        </div>

        <!-- Saisie de nombre -->
        <div class="display-content" *ngIf="Question.displayMode == 3">
            <mat-form-field class="quantity-form-field">
                <mat-label>Réponse</mat-label>
                <input matInput type="number" (keypress)="numericOnly($event)"  [(ngModel)]="option.result" (ngModelChange)="lessOrMore($event, option)">
            </mat-form-field>
        </div>

        <!-- Choix unique -->
        <div *ngIf="Question.displayMode == 2">
          <mat-selection-list #choices [multiple]="false" [(ngModel)]="selectedOptions" (ngModelChange)="onNgModelChange($event)">
            <mat-list-option *ngFor="let option of sortBy('order')" [value]="option">
                {{option.title}}
            </mat-list-option>
          </mat-selection-list>
        </div>

    </mat-expansion-panel>
</mat-accordion>



<div *ngIf="questions.length > 0 && show">
    <div *ngFor="let q of questions">
        <app-generic-display [Question]="q" [SurveyBase]="SurveyBase"></app-generic-display>
    </div>
</div>
